import type { MatchDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

function getMatchDetails(matchId: string): Promise<MatchDetailed> {
  return requestApiJsonOrThrow<MatchDetailed>(`admin/matches/${matchId}`)
}

export const matchDetailsQuery = (matchId: string) => ({
  queryKey: ['match', matchId],
  queryFn: () => getMatchDetails(matchId),
})
